import { useMemo } from "react"

import {
  RootState,
  selectTokenDecimals,
  selectWalletBalances,
  useDappSelector,
} from "#/redux-state"
import { SwappableToken } from "#/shared/types"
import { floatToBigInt } from "#/shared/utils"

import { useTokenUsdPrice } from "../token"

const useSwapReview = (
  token: SwappableToken,
  amount: string,
  slippage: number,
) => {
  const tokenDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, token),
  )

  const { mBTC } = useDappSelector(selectWalletBalances)

  // TODO: Read values from contract
  const networkFee = 0.0139
  const transactionFee = 0.0139

  const { getTokenUsdValue } = useTokenUsdPrice()

  const transactionTotal = useMemo(() => {
    const swapTokenValue = getTokenUsdValue(
      floatToBigInt(amount, tokenDecimals),
      token,
    )

    const networkFeeValue = floatToBigInt(networkFee, Number(mBTC.decimals))

    const networkFeeUsdValue = getTokenUsdValue(networkFeeValue, "mBTC")

    const transactionFeeValue = floatToBigInt(
      transactionFee,
      Number(tokenDecimals),
    )

    const transactionFeeUsdValue = getTokenUsdValue(transactionFeeValue, token)

    const feesValue = networkFeeUsdValue + transactionFeeUsdValue

    return feesValue + swapTokenValue
  }, [amount, token, tokenDecimals, mBTC.decimals, getTokenUsdValue])

  return {
    networkFee,
    transactionFee,
    transactionTotal,
    isSlippageToHigh: slippage >= 5,
  }
}

export default useSwapReview
